import base_config from "./base_config";

const dev_config = {
  ...base_config,
  STAGE: "dev",
  ACCOUNT: "181646698272",

  AUTH_PROVIDER: 'LASSO',

  get AMPLIFY_CONFIG(): any {
    const clientId = "3v6oq88v7lhcv03b2kao7t2bp4";

    return {
      aws_project_region: base_config.REGION,
      aws_cognito_region: base_config.REGION,
      aws_user_pools_id: "us-west-2_YFbfxWEKk",
      aws_user_pools_web_client_id: "4fjre7i55lopqp3gjb8dsboc80",
      oauth: {
        domain: "msaservice-beta.auth.us-west-2.amazoncognito.com",
        scope: base_config.TOKEN_SCOPES_ARRAY,
        redirectSignIn: base_config.CALL_BACK_URL,
        redirectSignOut: base_config.CALL_BACK_URL +'/?system=portal',
        responseType: base_config.OAUTH_RESPONSE_TYPE,
      },
    };
  },

  BASE_URL: "https://api.beta.msa.lab126.amazon.dev",
};

export default dev_config;
